import React, { useState, useEffect } from 'react';
import MedisLogoSvg from "../assets/svg/medisLogoSvg.svg"
import ImgBgOffcanvas from "../assets/img/bgOffcanvas.png"
import { HiMenuAlt3 } from "react-icons/hi";
import { IoMdClose } from "react-icons/io";
import IconUserAccSvg from '../assets/svg/iconUserNoAccSvg.svg';
import IconMyMedisSvg from '../assets/svg/iconMyMedisSvg.svg';
import IconMarketplaceSvg from '../assets/svg/iconMarketplace.svg';
import IconPersonSvg from '../assets/svg/iconUserMedis.svg';
import IconLogouteSvg from '../assets/svg/iconLogout.svg';
import '../css/header.css';
import { Link } from 'react-router-dom';
import NavDropdown from 'react-bootstrap/NavDropdown';
import ImgIconEuroCoin from '../assets/svg/iconEuroCoin.svg';
import { useMsal, useIsAuthenticated } from '@azure/msal-react';
import { useMobileMediaQuery, useTabletMediaQuery } from '../utils';
import Offcanvas from 'react-bootstrap/Offcanvas';
import { setUserName, setSaldoCarteira, setHasAccess } from '../features/onboardingData/onboardingUserData';
import { useSelector } from 'react-redux';
import { removeSecureData } from '../utils/secureStorage';
import { errorHandling } from '../utils';

function Header() {

    const isAuthenticated = useIsAuthenticated();
    const isUserName = useSelector((state) => state.onboardingUserData.isUserName);
    const isSaldoCarteira = useSelector((state) => state.onboardingUserData.isSaldoCarteira);
    const isHasAccess = useSelector((state) => state.onboardingUserData.isHasAccess);
    const isStatusCarteira = useSelector((state) => state.onboardingUserData.isStatusCarteira);
    const isMobile = useMobileMediaQuery();
    const isTablet = useTabletMediaQuery();
    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true)
    const [showUser, setShowUser] = useState(false);
    const handleCloseUser = () => setShowUser(false);
    const handleShowUser = () => setShowUser(true);
    const [showPopUp, setShowPopUp] = useState(false);
    const handleClosePopUp = () => setShowPopUp(false);
    const handleShowPopUp = () => setShowPopUp(true)



    const { instance } = useMsal();
    const handleLogout = async () => {
        try {
            removeSecureData('isSessionId');
            removeSecureData('isCookieId');
            removeSecureData('isHasAccess');
            removeSecureData('isAccessToken');
            removeSecureData('isAssociatedInsuraceList');
            removeSecureData('isNAssocia');
            removeSecureData('isRedirectUrl');
            removeSecureData('isTokenExpiresOn');
            const response = await instance.logout();
        } 
        catch (error) {
          errorHandling();
        }
    };

    return (
        <>
        { isTablet ?
            <div className='mainHeaderContainer'>
                <div className='secondHeaderContainer' >  
                    <div className='headeLogoNavSubContainer' >
                        <a href="https://saude360.medis.pt/" target="_blank" rel="noopener noreferrer">
                            <img className='medisLogoSvgIcon' src={MedisLogoSvg} alt="imagem" />
                        </a>
                        <div className='headerNavTxtView' >
                            <a href="https://www.medis.pt/" target="_blank" rel="noopener noreferrer" className="linkHeaderStyle">
                                <div className='txtDropDownHeader'>Seguros</div>
                            </a>
                        </div>
                        <div className='headerNavTxtView' >
                            <a href="https://www.medis.pt/saude-oral/" target="_blank" rel="noopener noreferrer" className="linkHeaderStyle">
                                <div className='txtDropDownHeader'>Saúde Oral</div>
                            </a>
                        </div>
                        <div className='headerNavTxtView' >
                            <a href="https://marketplace.medis.pt/" target="_blank" rel="noopener noreferrer" className="linkHeaderStyle">
                                <div className='txtDropDownHeader'>Marketplace</div>
                            </a>
                        </div>
                        <div className='headerNavTxtView' >
                            <a href="https://www.medis.pt/mais-medis" target="_blank" rel="noopener noreferrer" className="linkHeaderStyle">
                                <div className='txtDropDownHeader'>Biblioteca de Saúde</div>
                            </a>
                        </div>
                    </div>
                    <div className='headerFindAndUserProfContainer'>
                        <div className='headerInfoSaldoGoHomeViewContainer'>
                            <div className='headerInfoSaldoGoHomeSecondViewContainer'>
                                <div className='headerNavWioutHoverTxtView' >
                                    <Link to="/" className="linkHeaderStyle">
                                        <div className='txtDropDownHeader'>Carteira Virtual</div>
                                    </Link>
                                </div>
                                { isHasAccess ? (
                                    <div className='saldoInfoContainerHeader'>
                                        <div className="saldoEuroIconViewHeader">
                                            <img src={ImgIconEuroCoin} alt="€" className="saldoEuroIconHeader" />
                                        </div>
                                        <div className={ isStatusCarteira === '2' ? 'txtRegularSaldoHeaderSus' : 'txtRegularSaldoHeader'}>{`${isSaldoCarteira}€`}</div>
                                    </div>
                                    ) : (
                                        <div className="saldoEuroIconViewHeader">
                                            <img src={ImgIconEuroCoin} alt="€" className="saldoEuroIconHeader" />
                                        </div>
                                )}
                            </div>
                        </div>
                        { isAuthenticated ? (
                            <div className='headerUserAccIconLogedMainView'>
                                <div onClick={handleShowPopUp} className='headerUserAccIconLoged' style={{cursor:'pointer'}}>
                                    <div className='txtHeaderUserAccIconLoged'>{isUserName}</div>
                                </div>
                            </div>
                            ) : (
                                <div className='headerUserAccIconMainView' style={{cursor:'pointer', position: 'relative'}}>
                                    <img onClick={handleShowPopUp} className='headerUserAccIcon' src={IconUserAccSvg} alt='imagem' />
                                </div>
                        )}

                        { showPopUp &&
                            <div className='mainheaderNavViewContainerPopUp'>
                                <div className='btnCloseIconViewHeaderPopUp'>
                                    <button 
                                        className='btnCloseIconHeaderPopUp' 
                                        onClick={handleClosePopUp}>
                                            <IoMdClose className="closeIconHeaderPopUp"/>
                                    </button>
                                </div>
                                <div className='headerNavTxtView'>
                                    <a href="https://minhamedis-saude360.medis.pt/UmbrellaApplication_FE/Home" target="_blank" rel="noopener noreferrer" className="linkHeaderStyleMenuMobile">
                                        <img className='medisUserMenuSvgIconMobile' src={IconMyMedisSvg} alt="imagem" />
                                        <div className='txtDropDownHeader'>Minha Médis</div>
                                    </a>
                                </div>
                                <div className='headerNavTxtView'>
                                    <a href="https://minhamedis-saude360.medis.pt/UmbrellaApplication_FE/Perfil" target="_blank" rel="noopener noreferrer" className="linkHeaderStyleMenuMobile">
                                        <img className='medisUserMenuSvgIconMobile' src={IconPersonSvg} alt="imagem" />
                                        <div className='txtDropDownHeader'>Perfil</div>
                                    </a>
                                </div>
                                <div className='headerNavTxtView'>
                                    <a href="https://marketplace.medis.pt/" target="_blank" rel="noopener noreferrer" className="linkHeaderStyleMenuMobile">
                                        <img className='medisUserMenuSvgIconMobile' src={IconMarketplaceSvg} alt="imagem" />
                                        <div className='txtDropDownHeader'>Marketplace</div>
                                    </a>
                                </div>
                                <div className='headerDeviderLineMainViewMobile'>
                                    <div className='headerDeviderLine'></div>
                                </div>
                                <div className='headerNavTxtView'>
                                    <div onClick={handleLogout} className="linkHeaderStyleMenuMobile" style={{cursor:'pointer'}}>
                                        <img className='medisLogoutSvgIconMobile' src={IconLogouteSvg} alt="imagem" />
                                        <div className='txtDropDownHeaderMobile'>Terminar sessão</div>
                                    </div>
                                </div>
                            </div>
                        }

                    </div>
                </div>
            </div>
            :
            <div className='mainHeaderContainerMobile'>
                <a href="https://www.medis.pt/" target="_blank" rel="noopener noreferrer" className='medisLogoSvgIconViewMobile'>
                    <img className='medisLogoSvgIconMobile' src={MedisLogoSvg} alt="imagem" />
                </a>
                <div className='mainHeaderMenuContainerMobile'>
                    
                    <div className='headerInfoSaldoGoHomeViewContainer'>
                        { (isMobile && !isHasAccess) && (
                            <div className='headerNavTxtView' >
                                <Link to="/" className="linkHeaderStyle">
                                    <div className='txtDropDownHeader'>Carteira Virtual</div>
                                </Link>
                            </div>
                        )}
                        { isHasAccess ? (
                            <>
                            { isTablet && (
                                <div className='headerNavTxtView' >
                                    <Link to="/" className="linkHeaderStyle">
                                        <div className='txtDropDownHeader'>Carteira Virtual</div>
                                    </Link>
                                </div>
                            )}
                             <Link to="/" className="linkHeaderStyle">
                                <div className='saldoInfoContainerHeader'>
                                    <div className="saldoEuroIconViewHeader">
                                        <img src={ImgIconEuroCoin} alt="€" className="saldoEuroIconHeader" />
                                    </div>
                                    <div className={isStatusCarteira === '2' ? 'txtRegularSaldoHeaderSus' : 'txtRegularSaldoHeader'}>{`${isSaldoCarteira}€`}</div>
                                </div>
                            </Link>
                            </>
                            ) : (
                                (isMobile && (
                                    <Link to="/" className="linkHeaderStyle">
                                        <div className="saldoEuroIconViewHeader">
                                            <img src={ImgIconEuroCoin} alt="€" className="saldoEuroIconHeader" />
                                        </div>
                                    </Link>
                                ))
                                
                        )}
                    </div>
                    { isAuthenticated ? (
                        <div className='headerUserAccIconLogedMainView' style={{cursor:'pointer'}}>
                            <div onClick={handleShowUser} className='headerUserAccIconLoged'>
                                <div className='txtHeaderUserAccIconLoged'>{isUserName}</div>
                            </div>
                        </div>
                        ) : (
                            <div className='headerUserAccIconMainView' style={{cursor:'pointer'}}>
                                <img onClick={handleShowUser} className='headerUserAccIcon' src={IconUserAccSvg} alt='imagem' />
                            </div>
                    )}
                                    
                    <HiMenuAlt3 onClick={handleShow} className='headerFindIconMobile' />

                    <Offcanvas show={showUser} onHide={handleCloseUser} style={{ backgroundImage: `url(${ImgBgOffcanvas})`, backgroundSize: 'cover', backgroundPosition: 'center' }}>
                        <div className='mainheaderNavViewContainerMobile'>
                            <div className='btnCloseIconViewHeaderMobile'>
                                <button 
                                    className='btnCloseIconHeaderMobile' 
                                    onClick={handleCloseUser}>
                                        <IoMdClose className="closeIconHeaderMobile"/>
                                </button>
                            </div>
                            <div className='headerNavTxtViewMobile'>
                                <a href="https://minhamedis-saude360.medis.pt/UmbrellaApplication_FE/Home" target="_blank" rel="noopener noreferrer" className="linkHeaderStyleMenuMobile">
                                    <img className='medisUserMenuSvgIconMobile' src={IconMyMedisSvg} alt="imagem" />
                                    <div className='txtDropDownHeader'>Minha Médis</div>
                                </a>
                            </div>
                            <div className='headerNavTxtViewMobile'>
                                <a href="https://minhamedis-saude360.medis.pt/UmbrellaApplication_FE/Perfil" target="_blank" rel="noopener noreferrer" className="linkHeaderStyleMenuMobile">
                                    <img className='medisUserMenuSvgIconMobile' src={IconPersonSvg} alt="imagem" />
                                    <div className='txtDropDownHeader'>Perfil</div>
                                </a>
                            </div>
                            <div className='headerNavTxtViewMobile'>
                                <a href="https://marketplace.medis.pt/" target="_blank" rel="noopener noreferrer" className="linkHeaderStyleMenuMobile">
                                    <img className='medisUserMenuSvgIconMobile' src={IconMarketplaceSvg} alt="imagem" />
                                    <div className='txtDropDownHeader'>Marketplace</div>
                                </a>
                            </div>
                            <div className='headerDeviderLineMainViewMobile'>
                                <div className='headerDeviderLine'></div>
                            </div>
                            <div className='headerInfoSaldoGoHomeViewContainerMobile'>
                                <div className='headerNavTxtViewMobile' >
                                    <Link to="/" className="linkHeaderStyle">
                                        <div className='txtDropDownHeaderMobile'>Carteira Virtual</div>
                                    </Link>
                                </div>
                                { isHasAccess ? (
                                    <div className='saldoInfoContainerHeader'>
                                        <div className="saldoEuroIconViewHeader">
                                            <img src={ImgIconEuroCoin} alt="€" className="saldoEuroIconHeader" />
                                        </div>
                                        <div className={isStatusCarteira === '2' ? 'txtRegularSaldoHeaderSus' : 'txtRegularSaldoHeader'}>{`${isSaldoCarteira}€`}</div>
                                    </div>
                                    ) : (
                                    <div className="saldoEuroIconViewHeader">
                                        <img src={ImgIconEuroCoin} alt="€" className="saldoEuroIconHeader" />
                                    </div>
                                )}
                            </div>
                            <div className='headerDeviderLineMainViewMobile'>
                                <div className='headerDeviderLine'></div>
                            </div>
                            <div className='headerNavTxtViewMobile'>
                                <div onClick={handleLogout} className="linkHeaderStyleMenuMobile" style={{cursor:'pointer'}}>
                                    <img className='medisLogoutSvgIconMobile' src={IconLogouteSvg} alt="imagem" />
                                    <div className='txtDropDownHeaderMobile'>Terminar sessão</div>
                                </div>
                            </div>
                        </div>
                    </Offcanvas>
                </div>
                <Offcanvas show={show} onHide={handleClose}  style={{ backgroundImage: `url(${ImgBgOffcanvas})`, backgroundSize: 'cover', backgroundPosition: 'center' }}>
                    <div className='mainheaderNavViewContainerMobile'>
                        <div className='btnCloseIconViewHeaderMobile'>
                            <button 
                                className='btnCloseIconHeaderMobile' 
                                onClick={handleClose}>
                                    <IoMdClose className="closeIconHeaderMobile"/>
                            </button>
                        </div>
                        <div className='headerNavTxtViewMobile'>
                            <a href="https://www.medis.pt/" target="_blank" rel="noopener noreferrer" className="linkHeaderStyle">
                                <div className='txtDropDownHeader'>Seguros</div>
                            </a>
                        </div>
                        <div className='headerNavTxtViewMobile'>
                            <a href="https://www.medis.pt/saude-oral/" target="_blank" rel="noopener noreferrer" className="linkHeaderStyle">
                                <div className='txtDropDownHeader'>Saúde Oral</div>
                            </a>
                        </div>
                        <div className='headerNavTxtViewMobile'>
                            <a href="https://marketplace.medis.pt/" target="_blank" rel="noopener noreferrer" className="linkHeaderStyle">
                                <div className='txtDropDownHeader'>Marketplace</div>
                            </a>
                        </div>
                        <div className='headerNavTxtViewMobile'>
                            <a href="https://www.medis.pt/mais-medis" target="_blank" rel="noopener noreferrer" className="linkHeaderStyle">
                                <div className='txtDropDownHeader'>Biblioteca de Saúde</div>
                            </a>
                        </div>
                        <div className='headerDeviderLineMainViewMobile'>
                            <div className='headerDeviderLine'></div>
                        </div>
                        <div className='headerInfoSaldoGoHomeViewContainerMobile'>
                            <div className='headerNavTxtViewMobile' >
                                <Link to="/" className="linkHeaderStyle">
                                    <div className='txtDropDownHeaderMobile'>Carteira Virtual</div>
                                </Link>
                            </div>
                            { isHasAccess ? (
                                <div className='saldoInfoContainerHeader'>
                                    <div className="saldoEuroIconViewHeader">
                                        <img src={ImgIconEuroCoin} alt="€" className="saldoEuroIconHeader" />
                                    </div>
                                    <div className={isStatusCarteira === '2' ? 'txtRegularSaldoHeaderSus' : 'txtRegularSaldoHeader'}>{`${isSaldoCarteira}€`}</div>
                                </div>
                                ) : (
                                <div className="saldoEuroIconViewHeader">
                                    <img src={ImgIconEuroCoin} alt="€" className="saldoEuroIconHeader" />
                                </div>
                            )}
                        </div>
                    </div>
                </Offcanvas>
            </div> 
        }
        </>
    )
}

export default Header